module.exports = __webpack_public_path__ + "static/media/ipad.43653443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instaFeed/ipad.png
// module id = 360
// module chunks = 0